import { secureFetch } from "./securityUtil.js";
import { getMap } from './mapInstance.js';
import { API_URL } from './config.js';
import { refreshBootstrapTooltip } from './languageTranslator.js';
import './layerHierarchyService.css';

let labelsEnabled = false;

export function isLabelsEnabled() {
  return labelsEnabled;
}

function applyLabelToggle(layer, enabled) {

  // Handle group layers
  if (layer.getLayers) {
    layer.getLayers().forEach(child => applyLabelToggle(child, enabled));
    return;
  }

  const source = layer.getSource?.();

  if (!source) return;

  if (typeof layer.changed === 'function') {
    layer.changed();
  }

  if (typeof source.changed === 'function') {
    source.changed();
  }

  // Only WMS layers
  if (typeof source.updateParams === "function") {

    source.updateParams({
      SHOW_LABELS: enabled
    });

    source.refresh(); // VERY IMPORTANT
  }
}

function updateAllLayerLabels(enabled) {
  const map = getMap();
  if (!map) return;

  // Explicitly handle your groups
  [window.base_map, window.overlays, window.own_map].forEach(group => {
    if (!group) return;

    group.getLayers().forEach(layer => {
      applyLabelToggle(layer, enabled);
    });
  });
}

function updateLabelToggleButton(labelBtn) {
  labelBtn.classList.toggle('labels-enabled', labelsEnabled);
  labelBtn.classList.toggle('labels-disabled', !labelsEnabled);
  labelBtn.setAttribute('aria-pressed', String(labelsEnabled));
  const stateText = labelsEnabled ? 'ON' : 'OFF';
  const title = labelsEnabled ? 'Labels On' : 'Labels Off';
  labelBtn.setAttribute('title', title);
  labelBtn.setAttribute('aria-label', title);

  labelBtn.innerHTML = labelsEnabled
    ? '<i class="bi bi-toggle2-on fs-5"></i><span class="label-toggle-state">ON</span>'
    : '<i class="bi bi-toggle2-off fs-5"></i><span class="label-toggle-state">OFF</span>';

  refreshBootstrapTooltip(labelBtn, title);
}

export function initLayerControls() {

  const labelBtn = document.querySelector('.labels-toggle-button');

  if (!labelBtn) {
    console.error("Label toggle button not found!");
    return;
  }

  if (labelBtn.dataset.labelToggleBound === 'true') {
    updateLabelToggleButton(labelBtn);
    return;
  }

  labelBtn.dataset.labelToggleBound = 'true';
  updateAllLayerLabels(labelsEnabled);
  updateLabelToggleButton(labelBtn);

  labelBtn.addEventListener('click', () => {
    labelsEnabled = !labelsEnabled;

    updateAllLayerLabels(labelsEnabled);
    updateLabelToggleButton(labelBtn);
  });
}

export function renderLayerTree(data) {
  const baseList = document.getElementById("base-layers");
  baseList.innerHTML = "";

  data.forEach(layer => {
    baseList.appendChild(createNode(layer));
  });
}

function createNode(layer) {
  const li = document.createElement("li");
  li.classList.add("layer-item");

  const hasChildren = layer.children && layer.children.length > 0;

  const header = document.createElement("div");
  header.classList.add("layer-header");

  header.innerHTML = `
    ${hasChildren ? '<span class="toggle">▼</span>' : '<span class="no-toggle"></span>'}
    <span class="layer-name">${layer.name}</span>
    <span class="badge">${layer.addressCount || 0}</span>
  `;

  li.appendChild(header);

  if (hasChildren) {
    const ul = document.createElement("ul");
    ul.classList.add("nested");
    ul.style.display = "block";

    layer.children.forEach(child => {
      ul.appendChild(createNode(child));
    });

    // toggle expand
    header.addEventListener("click", () => {
      const isOpen = ul.style.display === "block";
      ul.style.display = isOpen ? "none" : "block";

      header.querySelector(".toggle").textContent = isOpen ? "▶" : "▼";
    });

    li.appendChild(ul);
  }

  return li;
}

export async function fetchLayerHierarchy(countryId, languageId) {
  const url = `${API_URL}base-layers/hierarchy?countryId=${countryId}&languageId=${languageId}`;

  const response = await secureFetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch layer hierarchy");
  }

  return await response.json();
}
